import { render, staticRenderFns } from "./BtnReturn.vue?vue&type=template&id=117db4c6&"
import script from "./BtnReturn.vue?vue&type=script&lang=js&"
export * from "./BtnReturn.vue?vue&type=script&lang=js&"
import style0 from "./BtnReturn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports